requestAnimationFrame(() => {
  class HeaderCalculateColumns extends HTMLElement {
    constructor() {
      super();
      this.handleResize = this.handleResize.bind(this);
      this.handleObservedResize = this.handleObservedResize.bind(this);
      this.resizeObserver = new ResizeObserver(this.handleObservedResize);
    }

    connectedCallback() {
      this.handleResize();
      window.addEventListener('throttle60fpsResize', this.handleResize);
    }

    disconnectedCallback() {
      this.teardown();
      window.removeEventListener('throttle60fpsResize', this.handleResize);
    }

    handleResize() {
      if (!themeBase?.isDesktop) {
        this.teardown();
        return;
      }
      this.setup();
    }

    handleObservedResize() {
      if (!this.isActive) return;
      this.update();
    }

    setup() {
      if (this.isActive) {
        this.update();
        return;
      }

      this.isActive = true;
      this.update();

      const contactEl = this.getContactMeasureEl();
      const iconsEl = this.getIconsMeasureEl();
      [contactEl, iconsEl].forEach((el) => {
        if (el) this.resizeObserver.observe(el);
      });
    }

    teardown() {
      if (!this.isActive) return;
      this.isActive = false;
      this.resizeObserver.disconnect();
      this.resetStyles();
    }

    resetStyles() {
      this.style.removeProperty('--header-side-width');
      this.classList.remove('header__first-line--no-sides');
      this.classList.remove('header__first-line--calculated-side-widths');
      delete this.dataset.sideWidth;
    }

    getMeasureWidth(element) {
      return element ? element.getBoundingClientRect().width : 0;
    }

    getContactMeasureEl() {
      return this.querySelector('.header__contact-btn') ||
        this.querySelector('.header__contact-content') ||
        this.querySelector('.header__contact');
    }

    getIconsMeasureEl() {
      return this.querySelector('.header__icons-group') ||
        this.querySelector('.header__icons');
    }

    update() {
      const contactEl = this.getContactMeasureEl();
      const iconsEl = this.getIconsMeasureEl();
      const contactWidth = this.getMeasureWidth(contactEl);
      const iconsWidth = this.getMeasureWidth(iconsEl);
      const side = Math.ceil(Math.max(contactWidth, iconsWidth));

      const prevSide = Number(this.dataset.sideWidth || -1);
      const prevNoSides = this.classList.contains('header__first-line--no-sides');
      const nextNoSides = side === 0;

      if (prevSide === side && prevNoSides === nextNoSides) return;

      this.style.setProperty('--header-side-width', `${side}px`);
      this.classList.toggle('header__first-line--no-sides', nextNoSides);
      this.classList.add('header__first-line--calculated-side-widths');
      this.dataset.sideWidth = side;
    }
  }

  if (!customElements.get('header-calculate-columns')) {
    customElements.define('header-calculate-columns', HeaderCalculateColumns);
  }
});